import { Controller, useFormContext, useWatch } from 'react-hook-form'
import { CurecallTextarea, CurecallTooltip, QuestionMarkIcon } from '@honestica/curecall-ui'
import { useTranslation } from 'react-i18next'
import { type TNodeFormValues } from '../node.type'
import { type TPatientLocale, ELocale } from 'src/types/locales'
import { useChatbotFlow } from '../chatbot.provider'

export function NodeClarificationMessageField() {
  const { t } = useTranslation()
  const { updateCurrentNodeData } = useChatbotFlow()

  const {
    formState: { errors },
    control,
    getValues,
  } = useFormContext<TNodeFormValues>()

  const messagesByLanguage = useWatch({ control, name: 'messagesByLanguage' })

  const LANGUAGE_ORDER: TPatientLocale[] = [ELocale.FR, ELocale.EN, ELocale.PL, ELocale.ES]

  const selectedLanguages = LANGUAGE_ORDER.filter((lang) => messagesByLanguage?.[lang] !== undefined)

  if (selectedLanguages.length === 0) {
    return null
  }

  return (
    <>
      <div className="c-border-b c-border-grey-400 c-w-full" />
      <div className="c-flex c-flex-col c-gap-2 c-m-4">
        {selectedLanguages.map((language) => (
          <Controller
            key={language}
            control={control}
            name={`clarificationMessage.${language}`}
            render={({ field }) => (
              <div className="c-flex c-flex-col c-gap-1">
                <div className="c-flex c-items-center c-gap-1">
                  <span className="c-text-sm c-text-gray-700">
                    {t('pages.configuration.followups.chatbot.node-form.clarification-message-title')} (
                    {language.toUpperCase()})
                  </span>
                  <CurecallTooltip
                    content={t(
                      'pages.configuration.followups.chatbot.node-form.clarification-message-tooltip',
                    )}
                    tooltipPosition="top"
                  >
                    <QuestionMarkIcon className="tw-h-5 tw-w-5 hover:tw-text-primary-500" />
                  </CurecallTooltip>
                </div>
                <CurecallTextarea
                  placeholder={t(
                    'pages.configuration.followups.chatbot.node-form.clarification-message-placeholder',
                  )}
                  value={field.value || ''}
                  onChange={(e) => {
                    field.onChange(e)
                    const currentClarificationMessages = getValues('clarificationMessage') || {}
                    updateCurrentNodeData({
                      clarificationMessage: { ...currentClarificationMessages, [language]: e.target.value },
                    })
                  }}
                  errorMessage={errors.clarificationMessage?.[language]?.message}
                  wrapperClassName="c-w-full"
                  textareaClassName="!c-h-[70px] !c-font-light"
                />
              </div>
            )}
          />
        ))}
      </div>
    </>
  )
}
